import React from "react";
import Table_display from "./Table_display";

function Display_report() {
  return <Table_display></Table_display>;
}

export default Display_report;
